import { render, staticRenderFns } from "./HelpOverlay.vue?vue&type=template&id=4fe55f62&"
import script from "./HelpOverlay.vue?vue&type=script&lang=js&"
export * from "./HelpOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe55f62')) {
      api.createRecord('4fe55f62', component.options)
    } else {
      api.reload('4fe55f62', component.options)
    }
    module.hot.accept("./HelpOverlay.vue?vue&type=template&id=4fe55f62&", function () {
      api.rerender('4fe55f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HelpOverlay.vue"
export default component.exports